<template>
  <div class="pt-10 px-6 pb-20 body">
    <div
      class="mb-5 last:mb-0 flex items-center bg-neutral-200 border border-neutral-300 rounded-md py-3 px-4 gap-3 cursor-pointer"
      v-for="addr in addresses"
      :key="'address-' + addr.id"
      @click="modifyAddress(addr.id)"
    >
      <img :src="iconsMapping[addr.asset_icon_id]" v-if="iconsMapping[addr.asset_icon_id]" />
      <img src="@/assets/images/icons/home.svg" v-else />
      <div>
        <div class="flex gap-3 mb-1">
          <p class="font-medium text-sm ">{{ addr.location_label }}</p>
          <p class="text-xs text-neutral-500 bg-neutral-300 py-1 px-2 rounded-md" v-if="addr.is_main">Utama</p>
        </div>
        <p class="font-medium text-xs text-neutral-500 ellipsis" :title="addr.address">{{ addr.address }}, {{ addr.detail_address }}</p>
      </div>
    </div>
    <div class="px-6 py-6 bg-white fixed bottom-0 left-0 z-1 w-full">
      <Button buttonText="Tambah Alamat" size="full" @action="addAddress()" />
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  components: {
    Button: () => import('@/components/Forms/Button')
  },
  computed: {
    ...mapGetters('merchant', ['addresses', 'isAddressModalVisible'])
  },
  data() {
    return {
      iconsMapping: {
        user: require('@/assets/images/icons/person.svg'),
        home: require('@/assets/images/icons/home.svg'),
        image: require('@/assets/images/icons/image.svg'),
        office: require('@/assets/images/icons/office.svg'),
        smile: require('@/assets/images/icons/smiled.svg'),
        star: require('@/assets/images/icons/star.svg'),
        heart: require('@/assets/images/icons/heart.svg'),
        basket: require('@/assets/images/icons/basket.svg')
      }
    }
  },
  mounted() {
    this.getAddressInformation()
  },
  methods: {
    ...mapActions('merchant', ['getAddresses', 'toggleAddressModal']),
    ...mapActions('common', ['showLoading', 'hideLoading', 'setToast']),
    getAddressInformation() {
      this.showLoading()
      this.getAddresses({ params: '' }).then(() => this.hideLoading())
    },
    addAddress() {
      this.toggleAddressModal({
        state: !this.isAddressModalVisible,
        mode: 'ADD'
      })
      this.$emit('dismiss')
    },
    modifyAddress(addressId) {
      this.toggleAddressModal({
        state: !this.isAddressModalVisible,
        mode: 'EDIT',
        addressId: addressId
      })
      this.$emit('dismiss')
    }
  }
}
</script>
<style lang="scss" scoped>
.body {
  height: calc(100vh - 52px);
  overflow-y: scroll;
}
.ellipsis {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.25;
  height: 16px;
  word-break: break-all;
}
</style>
